import { defineStore } from 'pinia'
import { v4 } from 'uuid'

interface ToastNotification {
  id?: string
  title: string
  text?: string
  type?: 'success' | 'error' | 'warning' | 'info'
  time?: number
}

export const useNotificationsStore = defineStore('notifications', {
  state: () => {
    return {
      notifications: [] as ToastNotification[]
    }
  },

  actions: {
    addNotification(notification: ToastNotification) {
      notification.id = v4()
      this.notifications.push(notification)
    },
    addSuccessNotification(title: string, text?: string) {
      this.addNotification({ title, text, type: 'success', time: 5000 })
    },
    addErrorNotification(title: string, text?: string) {
      this.addNotification({ title, text, type: 'error', time: 10000 })
    },
    removeNotification(id: string) {
      this.notifications = this.notifications.filter((n: any) => n.id !== id)
    }
  }
})
